import { Subscription } from "./Subscription";
import { CreditCard } from "./CreditCard";
import { makeAutoObservable } from "mobx";

export interface ICustomer {
    subscription?: Subscription;
    card?: CreditCard;
}

export class Customer implements ICustomer {
    subscription?: Subscription;
    card?: CreditCard;

    constructor(customer: ICustomer) {
        makeAutoObservable(this);

        this.subscription = customer.subscription ? new Subscription(customer.subscription) : undefined;
        this.card = customer.card ? new CreditCard(customer.card) : undefined;
    }

    setSubscription(subscription: Subscription) {
        this.subscription = subscription;
    }

    setCard(card?: CreditCard) {
        this.card = card;
    }
}